export const ExtendedCountryList = [
  {
    label: 'Andorra',
    value: 'AD',
  },
  {
    label: 'Albania',
    value: 'AL',
  },
  {
    label: 'Austria',
    value: 'AT',
  },
  {
    label: 'Åland Islands',
    value: 'AX',
  },
  {
    label: 'Bosnia and Herzegovina',
    value: 'BA',
  },
  {
    label: 'Belgium',
    value: 'BE',
  },
  {
    label: 'Bulgaria',
    value: 'BG',
  },
  {
    label: 'Belarus',
    value: 'BY',
  },
  {
    label: 'Switzerland',
    value: 'CH',
  },
  {
    label: 'Cyprus',
    value: 'CY',
  },
  {
    label: 'Czech Republic',
    value: 'CZ',
  },
  {
    label: 'Germany',
    value: 'DE',
  },
  {
    label: 'Denmark',
    value: 'DK',
  },
  {
    label: 'Estonia',
    value: 'EE',
  },
  {
    label: 'Spain',
    value: 'ES',
  },
  {
    label: 'Finland',
    value: 'FI',
  },
  {
    label: 'Faroe Islands',
    value: 'FO',
  },
  {
    label: 'France',
    value: 'FR',
  },
  {
    label: 'United Kingdom',
    value: 'GB',
  },
  {
    label: 'Guernsey',
    value: 'GG',
  },
  {
    label: 'Greece',
    value: 'GR',
  },
  {
    label: 'Croatia',
    value: 'HR',
  },
  {
    label: 'Hungary',
    value: 'HU',
  },
  {
    label: 'Ireland',
    value: 'IE',
  },
  {
    label: 'Isle of Man',
    value: 'IM',
  },
  {
    label: 'Iceland',
    value: 'IC',
  },
  {
    label: 'Italy',
    value: 'IT',
  },
  {
    label: 'Jersey',
    value: 'JE',
  },
  {
    label: 'Liechtenstein',
    value: 'LI',
  },
  {
    label: 'Lithuania',
    value: 'LT',
  },
  {
    label: 'Luxembourg',
    value: 'LU',
  },
  {
    label: 'Latvia',
    value: 'LV',
  },
  {
    label: 'Monaco',
    value: 'MC',
  },
  {
    label: 'Moldova, Republic of',
    value: 'MD',
  },
  {
    label: 'Macedonia, The Former Yugoslav Republic of',
    value: 'MK',
  },
  {
    label: 'Malta',
    value: 'MT',
  },
  {
    label: 'Netherlands',
    value: 'NL',
  },
  {
    label: 'Norway',
    value: 'NO',
  },
  {
    label: 'Poland',
    value: 'PL',
  },
  {
    label: 'Portugal',
    value: 'PT',
  },
  {
    label: 'Romania',
    value: 'RO',
  },
  {
    label: 'Russia',
    value: 'RU',
  },
  {
    label: 'Sweden',
    value: 'SE',
  },
  {
    label: 'Slovenia',
    value: 'SI',
  },
  {
    label: 'Svalbard and Jan Mayen',
    value: 'SJ',
  },
  {
    label: 'Slovakia',
    value: 'SK',
  },
  {
    label: 'San Marino',
    value: 'SM',
  },
  {
    label: 'Ukraine',
    value: 'UA',
  },
  {
    label: 'Holy See (Vatican City State)',
    value: 'VA',
  },
];
